import gql from 'graphql-tag';

export const MOVE_MEMBERS_TO_COMPLETED = gql`
  mutation MoveMembersToCompleted($memberIds: [Int!]!, $programId: Int!) {
    taskId: moveMembersToCompleted(memberIds: $memberIds, programId: $programId)
  }
`;
